// ==========================================================================
// CACTUS KNIGHT — Karussell-Komponente (Produktseite)
// Generisch nutzbar für mehrere Karussells auf einer Seite (Details,
// Bewertungen, ...). Für jedes Karussell:
// - Zeigt responsiv eine feste Anzahl Karten gleichzeitig
// - Pfeile scrollen um eine "Seite" weiter/zurück
// - Karten lassen sich per Klick+Ziehen (Maus) horizontal verschieben
// - Der Fortschrittsbalken unten ist klick- und ziehbar (Scrubbing)
// ==========================================================================

function ckInitCarousel(config) {
  const track = document.getElementById(config.trackId);
  const prevBtn = document.getElementById(config.prevId);
  const nextBtn = document.getElementById(config.nextId);
  const progressThumb = document.getElementById(config.progressThumbId);
  const progress = progressThumb ? progressThumb.closest(".details-carousel__progress") : null;
  if (!track || !prevBtn || !nextBtn) return;

  const GAP = 24;
  const itemClass = config.itemClass || "details-carousel__item";
  const desktopCount = config.desktopCount || 3;
  const tabletCount = config.tabletCount || 2;
  const mobileCount = config.mobileCount || 1.15;
  const alignArrowsToMedia = config.alignArrowsToMedia !== false;

  function visibleCount() {
    const w = window.innerWidth;
    if (w < 640) return mobileCount;
    if (w < 1000) return tabletCount;
    return desktopCount;
  }

  function layoutItems() {
    const items = track.querySelectorAll(`.${itemClass}`);
    if (items.length === 0) return;
    const n = visibleCount();
    const trackWidth = track.clientWidth;
    const itemWidth = (trackWidth - GAP * (n - 1)) / n;

    items.forEach((item) => {
      item.style.width = `${itemWidth}px`;
    });

    if (alignArrowsToMedia) {
      const mediaHeight = itemWidth * 0.75;
      prevBtn.style.top = `${mediaHeight / 2}px`;
      nextBtn.style.top = `${mediaHeight / 2}px`;
    } else {
      prevBtn.style.top = "50%";
      nextBtn.style.top = "50%";
    }
  }

  function scrollAmount() {
    const item = track.querySelector(`.${itemClass}`);
    if (!item) return track.clientWidth;
    return item.getBoundingClientRect().width + GAP;
  }

  function updateNav() {
    const maxScroll = track.scrollWidth - track.clientWidth;
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= maxScroll - 2;

    if (maxScroll <= 4) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
    } else {
      prevBtn.hidden = atStart;
      nextBtn.hidden = atEnd;
    }

    if (progressThumb) {
      const visibleRatio = Math.min(1, track.clientWidth / track.scrollWidth);
      const progressRatio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      progressThumb.style.width = `${visibleRatio * 100}%`;
      progressThumb.style.left = `${progressRatio * (100 - visibleRatio * 100)}%`;
    }
  }

  function refresh() {
    layoutItems();
    updateNav();
  }

  prevBtn.addEventListener("click", () => {
    track.scrollBy({ left: -scrollAmount(), behavior: "smooth" });
  });
  nextBtn.addEventListener("click", () => {
    track.scrollBy({ left: scrollAmount(), behavior: "smooth" });
  });

  track.addEventListener("scroll", updateNav);
  window.addEventListener("resize", refresh);
  window.addEventListener("hashchange", () => {
    requestAnimationFrame(refresh);
    setTimeout(refresh, 150);
  });
  document.addEventListener("ck-tab-changed", () => {
    requestAnimationFrame(refresh);
  });
  requestAnimationFrame(refresh);
  setTimeout(refresh, 150); // Fallback, falls Bilder/Layout erst später final sind

  // Zusätzliche Absicherung: Die Google-Schriftart (siehe @import in
  // style.css) lädt asynchron nach und kann dabei Kartenhöhen minimal
  // verschieben (Web-Font ersetzt die Fallback-Schrift, Text nimmt anderen
  // Platz ein). Ohne diese Neuberechnung blieb die per Pixel berechnete
  // Pfeil-Position (bei alignArrowsToMedia) danach stehen und "hing" leicht
  // daneben — sichtbar wurde das oft erst, nachdem man zu dem Bereich
  // heruntergescrollt hatte. document.fonts ist in praktisch allen
  // modernen Browsern verfügbar, daher kein zusätzlicher Fallback nötig.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refresh);
  }
  window.addEventListener("load", refresh);

  // ---- Klick + Ziehen auf den Karten (Drag-to-Scroll) ----
  // mousemove/mouseup werden bewusst nur waehrend eines aktiven Drags an
  // window gehaengt (statt dauerhaft) - sonst haette jedes der (mehreren)
  // Karussells auf der Seite permanent einen globalen mousemove-Listener,
  // der bei jeder Mausbewegung auf der ganzen Seite ausgewertet wird.
  let dragStartX = 0;
  let dragStartScroll = 0;
  let dragMoved = false;

  function onDragMove(e) {
    const delta = e.pageX - dragStartX;
    if (Math.abs(delta) > 3) dragMoved = true;
    track.scrollLeft = dragStartScroll - delta;
  }

  function onDragEnd() {
    track.classList.remove("is-dragging");
    window.removeEventListener("mousemove", onDragMove);
    window.removeEventListener("mouseup", onDragEnd);
  }

  track.addEventListener("mousedown", (e) => {
    dragMoved = false;
    dragStartX = e.pageX;
    dragStartScroll = track.scrollLeft;
    track.classList.add("is-dragging");
    window.addEventListener("mousemove", onDragMove);
    window.addEventListener("mouseup", onDragEnd);
  });

  track.addEventListener(
    "click",
    (e) => {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  // ---- Fortschrittsbalken: klick- und ziehbar (Scrubbing) ----
  // Auch hier haengen mousemove/mouseup nur waehrend des aktiven Scrubbings
  // an window, aus demselben Grund wie beim Drag-to-Scroll oben.
  if (progress) {
    function scrubTo(clientX) {
      const rect = progress.getBoundingClientRect();
      const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
      const maxScroll = track.scrollWidth - track.clientWidth;
      track.scrollLeft = ratio * maxScroll;
    }

    function onScrubMove(e) {
      scrubTo(e.clientX);
    }

    function onScrubEnd() {
      progress.classList.remove("is-scrubbing");
      track.classList.remove("is-dragging");
      window.removeEventListener("mousemove", onScrubMove);
      window.removeEventListener("mouseup", onScrubEnd);
    }

    progress.addEventListener("mousedown", (e) => {
      progress.classList.add("is-scrubbing");
      track.classList.add("is-dragging");
      scrubTo(e.clientX);
      window.addEventListener("mousemove", onScrubMove);
      window.addEventListener("mouseup", onScrubEnd);
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  ckInitCarousel({
    trackId: "details-track",
    prevId: "details-prev",
    nextId: "details-next",
    progressThumbId: "details-progress-thumb",
    desktopCount: 3,
    tabletCount: 2,
    mobileCount: 1.15,
  });

  ckInitCarousel({
    trackId: "reviews-track",
    prevId: "reviews-prev",
    nextId: "reviews-next",
    progressThumbId: "reviews-progress-thumb",
    desktopCount: 2,
    tabletCount: 2,
    mobileCount: 1.1,
    alignArrowsToMedia: false,
  });
});
